import { BookingType } from "@shared/enums/booking-type";

export class BookingFilter {
  from: Date;
  to: Date;
  userId: string;
  guideId: string;
  experienceId: string;
  status: string;
  includeActive: boolean;
  includeHistoric: boolean;
  includePending: boolean;
  includeUpcoming: boolean;
  includeReviewStatus: boolean;
  bookingType: string[];

  constructor() {
    this.from = null;
    this.to = null;
    this.userId = '';
    this.guideId = '';
    this.experienceId = '';
    this.status = '';
    this.includeActive = true;
    this.includeHistoric = false;
    this.includePending = false;
    this.includeUpcoming = false;
    this.includeReviewStatus = false;
    this.bookingType = [BookingType.CLASSROOM,BookingType.COURSE];
  }
}
